import { render, staticRenderFns } from "./AddressShow.vue?vue&type=template&id=28964ecd&scoped=true&"
import script from "./AddressShow.vue?vue&type=script&lang=js&"
export * from "./AddressShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28964ecd",
  null
  
)

export default component.exports